import Image from 'next/image';
import Link from 'next/link';
import Logo from '@/public/branding/bringtable-icon.svg';

interface BringtableLogoProps {
  className?: string;
  href?: string;
  showWordmark?: boolean;
}

export function BringtableLogo({
  className,
  href = '/',
  showWordmark = true,
}: BringtableLogoProps) {
  return (
    <Link
      href={href}
      className={className ?? 'inline-flex items-center gap-2'}
      aria-label="Bringtable home"
    >
      <span className="bg-black rounded-full p-0">
        <Image src={Logo} alt="Bringtable Logo" width={32} height={32} />
      </span>
      {showWordmark ? (
        <span className="text-lg font-semibold tracking-tight text-current">Bringtable</span>
      ) : null}
    </Link>
  );
}
